import { ChatInput } from './ChatInput'
import { ErrorDisplay } from './ErrorDisplay'
import { ChatMessage } from './ChatMessages/ChatMessage'
import { EmptyContent } from './ChatMessages/EmptyContent'
import { SendMessageButton } from './ChatButtons/SendMessageButton'
import { ChatActionContainer } from './ChatActionContainer'
import { DefaultLayout } from './DefaultLayout'
import type { FunctionComponent, ReactNode } from 'react'
import type { ContextType } from './Context'
import type { ChatSender } from '@ztechapps/common.contract'

export type ChatComponents = {
  input?: FunctionComponent<ChatInputProps>
  errorDisplay?: FunctionComponent<ChatComponentProps>
  messageContent?: FunctionComponent<ChatMessageProps>
  messageEmpty?: FunctionComponent
  chatActions?: {
    leftContent?: FunctionComponent<ChatComponentProps>
    otherButtons?: FunctionComponent<ChatComponentProps>
  }
  sendMessageButton?: FunctionComponent<ChatComponentProps>
  chatActionContainer?: FunctionComponent<ChatComponentProps>
  /** The whole mount's rendering — composer, action row and thread placement. Every mount but
   * the inbox keeps DefaultLayout; the inbox overrides it with its own scroll region and bare
   * sticky composer (Inbox/InboxThreadLayout.tsx). */
  layout?: FunctionComponent
}

export type ChatComponentProps = Omit<ContextType, 'components'>
export type ChatInputProps = Partial<ChatComponentProps> & { placeholder?: string }
export type ChatMessageProps = Partial<ChatComponentProps> & {
  from: ChatSender
  timeStamp: Date
  content: string
  currentUser: {
    _id: string
  }
  attachments: {
    _id?: string
    uri?: string
    name?: string
    isInline?: boolean
  }[]
  isLeft?: boolean
  children?: ReactNode
  borderStyle?: string
  sender?: ChatSender
  showEventsToo?: boolean
  // Whether the message is visible to the conversation's non-staff side. Optional; the default
  // `ChatMessage` marks a non-public message with no `externalId` as an internal note.
  isPublic?: boolean
  // The inbound email's Message-Id, absent on an internal note.
  externalId?: string
}

export const chatComponents: ChatComponents = {
  input: ChatInput,
  errorDisplay: ErrorDisplay,
  messageContent: ChatMessage,
  messageEmpty: EmptyContent,
  chatActions: {
    leftContent: () => null,
    otherButtons: (_props: any) => null,
  },
  sendMessageButton: SendMessageButton,
  chatActionContainer: ChatActionContainer,
  layout: DefaultLayout,
}
